import React from "react";

const ActionBadge = ({ action }) => {
  const a = String(action || "").toUpperCase();
  const MAP = {
    CREATE: { bg: "#dcfce7", c: "#16a34a", label: "Created" },
    UPDATE: { bg: "#eff6ff", c: "#2563eb", label: "Updated" },
    DELETE: { bg: "#fee2e2", c: "#dc2626", label: "Deleted" },
  };
  const s = MAP[a] || { bg: "#f1f5f9", c: "#64748b", label: action || "Change" };

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: 9.5,
        fontWeight: 700,
        padding: "2px 8px",
        borderRadius: 20,
        letterSpacing: ".05em",
        textTransform: "uppercase",
        fontFamily: "var(--fm)",
        background: s.bg,
        color: s.c,
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
    >
      {s.label}
    </span>
  );
};

export default ActionBadge;
